import React from 'react';
import { Flex } from 'grid-styled';
import { inject, observer } from 'mobx-react';

import Time from '../sections/Time';
import Versions from '../sections/Versions';
import Hardware from '../sections/Hardware';
import LicenseStatus from '../sections/LicenseStatus';

import Confirmation from '../form/Confirmation';

import Portal from '../uic/Portal';
import Backdrop from '../uic/Backdrop';
import PageModal from '../uic/PageModal';
import Upload from '../uic/Upload';
import ManagePassword from '../uic/ManagePassword';
import BusyOverlay from '../uic/BusyOverlay';

import Button from '../uic/Button';
import Section from '../uic/Section';
import session from '../session';

class Status extends React.Component {
    state = {
        showPortal: false,
        buttonState: false,
        hideEdit: true,
        showConfirmationFactory: false,
        errorNetwork: false,
        changePasswordPortal: false,
        autoUpdate: false,
        autoUpdateText: '?',
        dropbearText: '?',
        dropbearEnable: false
    };

    getDropbear = async () => {
        try {
            const sessionResult = await session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'dropbear',
                    section: 'RunCtl',
                    option: 'enable'
                }
            ]);

            if (sessionResult[1].value === '1') {
                this.state.dropbearText = 'ON';
                this.state.dropbearEnable = true;
            }
            if (sessionResult[1].value === '0') {
                this.state.dropbearText = 'OFF';
                this.state.dropbearEnable = false;
            }
        } catch (err) {
            console.error('getDropbear:' + err);
        }
    };

    setDropbear = async () => {
        try {
            this.state.dropbearEnable = !this.state.dropbearEnable;

            if (this.state.dropbearEnable) {
                await session.realm.fetch('/cgi/sshon.cgi');
            } else {
                await session.realm.fetch('/cgi/sshoff.cgi');
            }

            this.getDropbear();
        } catch (err) {
            console.error('setDropbear:' + err);
        }
    };

    getAutoUpdate = async () => {
        try {
            const sessionResult = await session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'security',
                    section: 'update',
                    option: 'automatic'
                }
            ]);

            if (sessionResult[1].value === 'true') {
                this.state.autoUpdateText = 'ON';
                this.state.autoUpdate = true;
            }
            if (sessionResult[1].value === 'false') {
                this.state.autoUpdateText = 'OFF';
                this.state.autoUpdate = false;
            }
        } catch (err) {
            console.error('getAutoUpdate:' + err);
        }
    };

    setAutoUpdate = async () => {
        try {
            this.state.autoUpdate = !this.state.autoUpdate;

            await session.rpc('call', [
                '',
                'uci',
                'set',
                {
                    config: 'security',
                    section: 'update',
                    values: { automatic: this.state.autoUpdate }
                }
            ]);

            const sessionResult = await session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'security',
                    section: 'update',
                    option: 'automatic'
                }
            ]);
            if (sessionResult[1].value === 'true') {
                this.state.autoUpdateText = 'ON';
                this.state.autoUpdate = true;
            }
            if (sessionResult[1].value === 'false') {
                this.state.autoUpdateText = 'OFF';
                this.state.autoUpdate = false;
            }
        } catch (err) {
            console.error('setAutoUpdate:' + err);
        }
    };

    load = async () => {
        try {
            this.getAutoUpdate();
            this.getDropbear();

            if (session.user === 'user') {
                //
                this.setState({ hideEdit: true });
            }
            if (session.user === 'admin') {
                //
                this.setState({ hideEdit: false });
            }
        } catch (err) {
            console.error('Status:' + err);
        }
    };

    componentWillMount() {
        if (session.user === 'user') {
            //
            this.setState({ hideEdit: true });
        }
        if (session.user === 'admin') {
            //
            this.setState({ hideEdit: false });
        }
    }
    componentDidMount() {
        this._timer_status = setInterval(this.load, 2000);
    }

    componentWillUnmount() {
        if (this._timer_status) {
            clearInterval(this._timer_status);
        }
        if (this._timer_reset) {
            clearTimeout(this._timer_reset);
        }
    }

    myCallback = dataFromChild => {
        this.setState({ errorNetwork: dataFromChild.errorNetwork });
    };

    close = variableClose => this.setState({ [variableClose]: false });

    resetSettings = async () => {
        try {
            this.setState({ buttonState: true });

            const sessionResult = await session.rpc(
                'call',
                ['', 'system', 'factory_defaults', {}],
                { timeout: 5 * 60000 }
            );

            if (sessionResult[1].status === 'OK') {
                this._timer_reset = setTimeout(this.resetSettings_aux, 5000);
            }
        } catch (err) {
            console.error('setAutoUpdate:' + err);
        }
    };

    resetSettings_aux = async () => {
        this.setState({
            buttonState: false,
            showConfirmationFactory: false
        });
        this.getAutoUpdate();
        this.getDropbear();
    };

    render() {
        return (
            <Flex flexWrap="wrap">
                {this.state.buttonState && <BusyOverlay />}
                <Section title="Actions" width="100%">
                    {!this.state.hideEdit && (
                        <Flex style={{ justifyContent: 'space-between' }}>
                            <Flex flexDirection="column">
                                <Flex>
                                    <Button
                                        onClick={this.setAutoUpdate}
                                        icon="autorenew"
                                        minWidth={220}
                                    >
                                        Automatic updates{' '}
                                        {this.state.autoUpdateText}
                                    </Button>

                                    <Button
                                        onClick={this.setDropbear}
                                        icon="autorenew"
                                        minWidth={220}
                                    >
                                        Secure Shell {this.state.dropbearText}
                                    </Button>
                                </Flex>

                                <Flex>
                                    <Button
                                        icon="cloud_upload"
                                        minWidth={220}
                                        onClick={() =>
                                            this.setState({
                                                showPortal: !this.state
                                                    .showPortal
                                            })
                                        }
                                    >
                                        Update firmware
                                    </Button>

                                    <Button
                                        minWidth={220}
                                        icon="lock"
                                        onClick={() =>
                                            this.setState({
                                                changePasswordPortal: !this
                                                    .state.changePasswordPortal
                                            })
                                        }
                                    >
                                        Manage Passwords
                                    </Button>
                                </Flex>
                            </Flex>
                            <Flex flexDirection="column">
                                <Button
                                    bg="dangerRed"
                                    minWidth={220}
                                    icon="restore"
                                    onClick={() =>
                                        this.setState({
                                            showConfirmationFactory: !this.state
                                                .showConfirmationFactory
                                        })
                                    }
                                >
                                    Factory defaults
                                </Button>
                            </Flex>
                        </Flex>
                    )}
                </Section>
                <Versions session={this.props} />
                <Hardware
                    session={this.props}
                    callbackFromParent={this.myCallback}
                />
                <Time session={this.props} />
                <LicenseStatus session={this.props} />

                <Section title="Help">
                    <p>
                        <b>General</b>
                        <br />
                        This page provides commands to manage the device and
                        information useful to our support team, in case of
                        problem.
                        <br />
                    </p>
                    <p>
                        <b>Versions</b>
                        <br />
                        This section displays the different modules present in
                        the firmware along with their versions to help us track
                        issues.
                        <br />
                    </p>
                    <p>
                        <b>Hardware</b>
                        <br />
                        This section show information about your device and its
                        underlying hardware.
                        <br />
                    </p>
                    <p>
                        <b>Time</b>
                        <br />
                        This section displays your local time as well as the NTP
                        server(s) it relies on
                        <br />
                    </p>
                    <p>
                        <b>License</b>
                        <br />
                        This section contains information about your device's
                        license. If the status is "INVALID", the Instreamer
                        ICE's functionality will be disabled.
                        <br />
                    </p>
                    <p>
                        <b>Actions</b>
                        <br />
                        In this section, you are provided with tools to manage
                        your device
                        <br />
                        <br />
                        <i>Automatic update</i>
                        <br />
                        <br />
                        Click on the "Automatic Updates on/off" button to enable
                        or disable the feature. The automatic firmware update is
                        carried out, if enabled and available, on Tuesdays
                        between 4AM and 5AM of your time zone.
                        <br />
                        <br />
                        <i>Update firmware</i>
                        <br />
                        <br />
                        Click on the "Update Firmware" button and either drag
                        and drop or upload a different image of the Instreamer
                        ICE.
                        <br />
                        <br />
                        <i>Manage passwords</i>
                        <br />
                        <br />
                        Click on the "Manage passwords" to enter the wizard to
                        change passwords related to the UI and/or the Icecast
                        server.
                        <br />
                        <br />
                        <i>Restore Factory Settings</i>
                        <br />
                        <br />
                        Click on the "Restore Factory Settings" button if you
                        wish to wipe all changes you made (network, streaming,
                        passwords) and return to a factory state.
                        <br />
                    </p>
                </Section>
                {this.state.showPortal && (
                    <Portal>
                        <Backdrop>
                            <PageModal
                                errorsPage="true"
                                hidebuttons="true"
                                header="Firmware Update"
                                close={() => this.close('showPortal')}
                            >
                                <Upload urllink="/sys/cgi-bin/updater.cgi" />
                            </PageModal>
                        </Backdrop>
                    </Portal>
                )}
                {this.state.showConfirmationFactory && (
                    <Portal>
                        <Backdrop>
                            <PageModal
                                errorsPage="true"
                                hidebuttons="true"
                                header="Restore factory settings"
                                close={() =>
                                    this.close('showConfirmationFactory')
                                }
                            >
                                <Confirmation
                                    confirm={this.resetSettings}
                                    bodytext="Are you sure you want to reset the device to factory defaults?"
                                    confirmText="Yes"
                                    title="Restore factory settings"
                                    uploadinprogress={this.state.buttonState}
                                    close={() =>
                                        this.close('showConfirmationFactory')
                                    }
                                />
                            </PageModal>
                        </Backdrop>
                    </Portal>
                )}
                {this.state.changePasswordPortal && (
                    <Portal>
                        <Backdrop>
                            <PageModal
                                errorsPage="true"
                                hidebuttons="true"
                                header="Manage passwords"
                                close={() => this.close('changePasswordPortal')}
                            >
                                <ManagePassword
                                    session={session}
                                    close={() =>
                                        this.close('changePasswordPortal')
                                    }
                                />
                            </PageModal>
                        </Backdrop>
                    </Portal>
                )}
            </Flex>
        );
    }
}

export default inject('session')(observer(Status));



// WEBPACK FOOTER //
// ./src/pages/Status.js